import { createContext } from 'react';

export interface TokenContextValue {
   accessToken: string | undefined;
   isLoading: boolean;
   refreshToken: () => Promise<void>;
}

export const TokenContext = createContext<TokenContextValue>({
   accessToken: undefined,
   isLoading: false,
   refreshToken: async () => {
     // no-op
   }
});
